<template>
  <div>
    <address-book
      :show="show"
      @ab-cancel="onClose"
      @ab-selected="onSelect"
    />
  </div>
</template>

<script setup>
import { closeDialog } from 'vue3-promise-dialog'
import { onMounted, ref } from 'vue'
import AddressBook from '@/modules/obu_booking/ObuBookingsAddressBook.vue'
import { useContactStore } from '@/pinia/ContactStore.js'
import { storeToRefs } from 'pinia'

const contactStore = useContactStore()
const { contact } = storeToRefs(contactStore)

onMounted(async () => {
  show.value = true
  await contactStore.load()
})

const show = ref(true)

const onClose = () => {
  closeDialog(false)
}

const onSelect = () => {
  closeDialog(contact.value)
}
</script>
